import { renderFullNameColumn, renderHpRolesColumn } from './helpers/renderColumns'
import { TContactTableColumn } from './models'

export const contactTableColumns: Array<TContactTableColumn> = [
  {
    columnTitle: 'cng-contact_creator-partner_hp_roles_table-hp_roles',
    columnField: 'hpRoles',
    render: renderHpRolesColumn,
  },
  {
    columnTitle: 'cng-contact_creator-partner_hp_roles_table-name',
    columnField: 'firstName',
    styles: { width: '400px' },
    render: renderFullNameColumn,
  },
  {
    columnTitle: 'cng-contact_creator-partner_hp_roles_table-email',
    columnField: 'email',
    styles: { maxWidth: '300px', width: '300px' },
  },
]
